var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMetamask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3618 1.30005L13.377 7.94818L15.0478 4.03022L22.3618 1.30005Z",
    fill: "#E17726",
    stroke: "#E17726",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.6377 1.30005L10.5425 8.01022L8.95175 4.03021L1.6377 1.30005Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1269 16.7148L16.7363 20.3669L21.8553 21.7763L23.3217 16.7947L19.1269 16.7148Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.686523 16.7947L2.14399 21.7763L7.25406 20.3669L4.87231 16.7148L0.686523 16.7947Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.97854 10.5453L5.55664 12.6905L10.6222 12.9209L10.4534 7.46948L6.97854 10.5453Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0206 10.5454L13.4925 7.40747L13.377 12.921L18.4425 12.6905L17.0206 10.5454Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.25391 20.3669L10.3199 18.8866L7.6805 16.8301L7.25391 20.3669Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6797 18.8866L16.7368 20.3669L16.3191 16.8301L13.6797 18.8866Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7368 20.367L13.6797 18.8867L13.9285 20.8723L13.9018 21.7144L16.7368 20.367Z",
    fill: "#D5BFB2",
    stroke: "#D5BFB2",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M7.25391 20.367L10.0978 21.7144L10.08 20.8723L10.3199 18.8867L7.25391 20.367Z",
    fill: "#D5BFB2",
    stroke: "#D5BFB2",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1511 15.5182L7.60938 14.7736L9.40455 13.9492L10.1511 15.5182Z",
    fill: "#233447",
    stroke: "#233447",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8486 15.5182L14.5952 13.9492L16.3992 14.7736L13.8486 15.5182Z",
    fill: "#233447",
    stroke: "#233447",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M7.25377 20.3669L7.69816 16.7148L4.87207 16.7947L7.25377 20.3669Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3008 16.7148L16.7363 20.3669L19.1269 16.7947L16.3008 16.7148Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4425 12.6904L13.377 12.9209L13.8479 15.5182L14.5945 13.9491L16.3985 14.7735L18.4425 12.6904Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M7.60954 14.7735L9.40471 13.9491L10.1513 15.5182L10.6222 12.9209L5.55664 12.6904L7.60954 14.7735Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M5.55664 12.6904L7.68066 16.83L7.60951 14.7735L5.55664 12.6904Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3993 14.7735L16.3193 16.83L18.4433 12.6904L16.3993 14.7735Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6224 12.9209L10.1514 15.5182L10.7468 18.5851L10.8801 14.5431L10.6224 12.9209Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3778 12.9209L13.1289 14.5342L13.2533 18.5851L13.8488 15.5182L13.3778 12.9209Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8484 15.5183L13.2529 18.5853L13.6795 18.8867L16.319 16.8302L16.399 14.7737L13.8484 15.5183Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M7.60938 14.7737L7.68052 16.8302L10.3199 18.8867L10.7465 18.5853L10.1511 15.5183L7.60938 14.7737Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9014 21.7143L13.928 20.8722L13.697 20.6772H10.3022L10.08 20.8722L10.0978 21.7143L7.25391 20.3669L8.24925 21.1824L10.2666 22.5741H13.7236L15.7499 21.1824L16.7363 20.3669L13.9014 21.7143Z",
    fill: "#C0AC9D",
    stroke: "#C0AC9D",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6793 18.8865L13.2527 18.5852H10.7466L10.3201 18.8865L10.0801 20.8722L10.3023 20.6771H13.6971L13.9282 20.8722L13.6793 18.8865Z",
    fill: "#161616",
    stroke: "#161616",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7444 8.3825L23.4998 4.71276L22.3623 1.30005L13.6797 7.7266L17.0212 10.5454L21.7402 11.9193L22.78 10.705L22.3268 10.3769L23.0466 9.72105L22.4956 9.29555L23.2155 8.74595L22.7444 8.3825Z",
    fill: "#763E1A",
    stroke: "#763E1A",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 4.71276L1.26429 8.3825L0.775501 8.74595L1.50423 9.29555L0.953239 9.72105L1.67309 10.3769L1.21985 10.705L2.25963 11.9193L6.97868 10.5454L10.3202 7.7266L1.63754 1.30005L0.5 4.71276Z",
    fill: "#763E1A",
    stroke: "#763E1A",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7404 11.9193L17.0214 10.5454L18.4433 12.6906L16.3193 16.8301L19.1276 16.7946H23.3223L21.7404 11.9193Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M6.97851 10.5454L2.25953 11.9193L0.686523 16.7946H4.87231L7.68059 16.8301L5.55662 12.6906L6.97851 10.5454Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3779 12.9211L13.6801 7.7266L15.0486 4.03027H8.95215L10.3207 7.7266L10.6229 12.9211L10.7384 14.552L10.7473 18.5853H13.2535L13.2624 14.552L13.3779 12.9211Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetamask);
export default __webpack_public_path__ + "static/media/metamask.e3f820d8881a438e20d29e818bd1c862.svg";
export { ForwardRef as ReactComponent };